/*
 * File: formatUpdateInfo.ts
 * Author: Austin Robinson
 * Date Created: 12/07/2025
 * Copyright (c) DrivingDoc 2025
 */
import dayjs from 'dayjs';

import { MinimalUser } from 'api';

/**
 * Formats audit trail information showing when and by whom something was last updated.
 *
 * @param updatedAt - ISO timestamp of when the update occurred
 * @param updatedBy - User object containing first and last name
 * @returns Formatted string like "Last updated 2 hours ago by John Doe", or null if no data
 *
 * @example
 * formatUpdateInfo('2025-01-28T10:00:00Z', { first_name: 'John', last_name: 'Doe' })
 * // "Last updated 2 hours ago by John Doe"
 */
export function formatUpdateInfo(updatedAt?: string | null, updatedBy?: MinimalUser | null): string | null {
  if (!updatedAt || !updatedBy || !updatedBy.first_name || !updatedBy.last_name) return null;
  return `Last updated ${dayjs().to(dayjs(updatedAt))} by ${updatedBy.first_name} ${updatedBy.last_name}`;
}